<div>
    <div *ngFor="let attribute of attributes">
        <div class="attributeRow">
            <div>
                <div *ngIf="attribute.description" matTooltip="{{ attribute.description }}"
                    [matTooltipPosition]="'below'" matTooltipClass="tooltip">
                    <img [src]="'/assets/img/icons/info.png'" alt="Beschreibungs-Icon" />
                </div>
            </div>
            <div>
                <p *ngIf="!optional">
                    {{ attribute.name }}
                </p>
                <p *ngIf="optional">{{ attribute.name }} (optional)</p>
            </div>
            <div>
                <toggle-switch id="{{ attribute.id }}" [disableToggle]="hasAttributeConflict(attribute)"
                    [trueLabel]="'Ja'" [falseLabel]="'Nein'" [allowUndefined]="true" [value]="
                        attributeValidationService.activeEntityFeatureValues.get(
                            attribute.id
                        )
                    " (valueChange)="onAttributeValueChange(attribute, $event)">
                </toggle-switch>
            </div>
            <div>
                <validation-icon [value]="
                        attributeValidationService.attributesValidated.get(
                            attribute.id
                        )
                    "></validation-icon>
            </div>
            <div *ngIf="editable">
                <red-cross-button (click)="removeAttribute(attribute)"></red-cross-button>
            </div>
        </div>
        <div *ngIf="hasAttributeConflict(attribute)" class="conflict-error">
            {{ getConflictErrorMessage(attribute) }}
        </div>
    </div>
</div>